import { render, staticRenderFns } from "./downBtn.vue?vue&type=template&id=6185e0f3&scoped=true"
import script from "./downBtn.vue?vue&type=script&lang=js"
export * from "./downBtn.vue?vue&type=script&lang=js"
import style0 from "./downBtn.vue?vue&type=style&index=0&id=6185e0f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6185e0f3",
  null
  
)

export default component.exports